import { render, staticRenderFns } from "./projectUserReport.vue?vue&type=template&id=e12c952e"
import script from "./projectUserReport.vue?vue&type=script&lang=js"
export * from "./projectUserReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports